module.exports = __webpack_public_path__ + "img/FAJRLOGO01.e73643b6.png";